import { cn } from "@omni/utils/styles";

import { Pagination } from "@/components/General/Pagination/pagination.container";
import { useThunkDispatch } from "@/redux/dispatcher";
import { configureSearchComponent } from "@/redux/modules/value/search/search.actions";
import { useSearchComponentStateSelector } from "@/redux/modules/value/search/search.selectors";
import { getInvalidationsForComponent } from "@/utils/search/invalidation.utils";
import { ResultListHitType } from "@/utils/search/types/internal/resultListHitType.enum";
import { SearchComponentOfType } from "@/utils/search/types/searchComponent";

import { DefaultHitsPerPage } from "../../../productsResults/components/resultsView/components/filters/components/productHitsPerPage/hitsPerPage.config";

type PaginationProps = {
    className?: string;
    resultListComponent: SearchComponentOfType<"RESULT_LIST">;
    paginationComponent: SearchComponentOfType<"PAGINATION">;
    hitsPerPageComponent: SearchComponentOfType<"HITS_PER_PAGE">;
    numberOfHitsComponent: SearchComponentOfType<"NUMBER_OF_HITS">;
};

const SearchPagination = ({
    className,
    resultListComponent,
    paginationComponent,
    hitsPerPageComponent,
    numberOfHitsComponent
}: PaginationProps) => {
    const dispatch = useThunkDispatch();

    const resultListState =
        useSearchComponentStateSelector(resultListComponent);
    const hitsPerPage =
        useSearchComponentStateSelector(hitsPerPageComponent)?.hitsPerPage ??
        DefaultHitsPerPage;
    const numberOfHits =
        useSearchComponentStateSelector(numberOfHitsComponent)?.numberOfHits ??
        0;

    const amountOfHitsWithInjectedContentBlocks =
        resultListState?.hits.length ?? 0;
    const amountOfHitsWithoutInjectedBlocks =
        resultListState?.hits.filter(
            (hit) => hit.type !== ResultListHitType.INJECTED
        ).length ?? 0;

    const totalHits = numberOfHits;
    const amountOfHits = amountOfHitsWithoutInjectedBlocks;

    const loadNextPage = () => {
        dispatch(
            configureSearchComponent(
                {
                    component: paginationComponent,
                    hitsWithInjected: amountOfHitsWithInjectedContentBlocks,
                    hitsWithoutInjected: amountOfHitsWithoutInjectedBlocks
                },
                getInvalidationsForComponent(paginationComponent)
            )
        );
    };

    return (
        <Pagination
            className={cn(className)}
            currentNumberOfHits={amountOfHits}
            totalNumberOfHits={totalHits}
            hitsPerPage={hitsPerPage}
            onLoadMore={loadNextPage}
        />
    );
};

export { SearchPagination };
